import React from 'react';
import Chart from "chart.js";

class MonitorTypes extends React.Component {
  constructor(props) {
    super(props)
    this.chartRef = React.createRef();
  }
  componentDidMount() {
    const myChartRef = this.chartRef.current.getContext("2d");
    new Chart(myChartRef, {
      type: 'pie',
      data: {
          labels: ['Audio Only', 'Video & Audio (Wi-Fi)', 'Video & Audio (No Wi-Fi)'],
          datasets: [{
              data: [10, 55, 35],
              average: [29.49, 64.81, 94.41],
              backgroundColor: [
                'rgba(255, 159, 64, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)'
              ],
              hoverBackgroundColor: [
                'rgba(255, 159, 64, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(153, 102, 255, 1)'
              ],
              borderColor: [
                'rgba(255, 159, 64, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(153, 102, 255, 1)'
              ],
              borderWidth: 1
          }]
      },
      options: {
        maintainAspectRatio: false,
        legend: {
            labels: {
                // This more specific font property overrides the global property
                fontSize: 20
            }
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              //console.log(data['datasets'][0]['data']);
              //console.log(tooltipItem['index']);
              let index = tooltipItem['index'];
              let average = data['datasets'][0]['average'][index];
              let percentage = data['datasets'][0]['data'][index];
              return data['labels'][tooltipItem['index']] + " (Average Price: $" + average + "): " + percentage + '%';
            }
          }
        }
      }
    });
  }
  render() {
        return (
          <div className="chart-container">
            <canvas id="type" ref={this.chartRef} aria-label="Pie chart that displays the data described in the above paragraph." role="img">
              <p>
                Pie chart that displays the data described in the above paragraph.
              </p>
            </canvas>
          </div>
        )
    }
}

export default MonitorTypes;
